import { IActiveDirectorySuggestion } from "@/interfaces";

interface ISuggestionOption {
  value: string;
  label: string;
}

export const transformGroupSuggestionsToOptions = (
  suggestions: IActiveDirectorySuggestion[]
): ISuggestionOption[] =>
  suggestions?.map(({ document: { id, displayName } }) => ({
    value: id,
    label: displayName,
  }));
